module.exports = __webpack_public_path__ + "img/ans_logo_lite.5b954575.png";